import React from 'react';
import TitleHashtag from './TitleHashtag';
import { st, classes } from './Hashtags.st.css';

const AsyncHashtagsGallery = React.lazy(() =>
  import(/* webpackChunkName: "hashtagsGallery" */ './hashtagsGallery'),
);

const Hashtags = () => (
  <div className={st(classes.root)}>
    <TitleHashtag />
    <AsyncHashtagsGallery />
  </div>
);

export default Hashtags;
